import Chat from "../components/Chat/Chat";
import FullPageLayout from "../components/FullPageLayout";

const MainChat = () => {
  return (
    <FullPageLayout className="">
      <Chat />
    </FullPageLayout>
  )
}

export default MainChat;